import clsx from 'clsx';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';
import { WHITE } from '../../backend/helpers/Theme';
import { Clock } from './icons/Clock';
import { TapIcon } from './KioskIcons';

const getBackgroundColor = (theme, animate = false) => {
  if (theme.palette.contrastText === WHITE) {
    return animate ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)';
  }

  return animate ? 'rgba(0, 0, 0, 0.05)' : 'rgba(0, 0, 0, 0.15)';
};

const useStyles = createUseStyles((theme) => ({
  subtitle: {
    fontSize: '2.25rem',
  },
  tapIcon: {
    backgroundColor: getBackgroundColor(theme),
    animation: '$pulseColor 1.5s infinite ease-in-out',
  },
  pulseScale: {
    animation: '$pulseScale 1.5s infinite cubic-bezier(0.5,2.5,0,1)',
  },
  '@keyframes pulseScale': {
    '0%, 100%': { transform: 'scale(0.92)' },
    '50%': { transform: 'scale(1.175)' },
  },
  '@keyframes pulseColor': {
    '0%, 100%': { backgroundColor: getBackgroundColor(theme) },
    '50%': { backgroundColor: getBackgroundColor(theme, true) },
  },
}));

export const KioskIdle = () => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <section
      aria-label={intl.formatMessage({ id: 'Landing.kiosk.touch' })}
      className="text-center w-full"
      onPointerUp={(e) => {
        e.stopPropagation();
      }}
      onTouchEnd={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="max-w-4xl px-12 h-full m-auto flex flex-col items-center gap-7 justify-center">
        <div className="flex flex-col gap-5 items-center justify-center">
          <h1 className="text-5xl font-semibold mb-2" id="title">
            <FormattedMessage id="Landing.kiosk.title" />
          </h1>
          <h2 className={clsx(classes.subtitle, 'font-medium')}>
            <FormattedMessage id="Landing.kiosk.subtitle" />
          </h2>
          <div className="flex gap-4 items-center justify-center">
            <Clock aria-hidden className="w-7 h-7 hidden sm:block" />
            <h3 className="text-2xl">
              <FormattedMessage id="Landing.kiosk.hours_temp" />
            </h3>
          </div>
        </div>
        <hr className="bg-current rounded-full h-0.5 w-full my-8 border-0 opacity-25" />
        <div className={`${classes.tapIcon} p-6 rounded-full`}>
          <TapIcon className={classes.pulseScale} />
        </div>
        <p className="text-xl uppercase">
          <FormattedMessage id="Landing.kiosk.touch" />
        </p>
      </div>
    </section>
  );
};
